module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2GvMw"))).then(() => parcelRequire('3a9aZ'));